import { getEndpoint } from "@api-routes/endpoint";

const NOTIFICATIONS_MS_NAME = "notifications";
export const dismissNotificationRoute = (alertId: number) =>
    `${getEndpoint(NOTIFICATIONS_MS_NAME)}web_notification/${alertId}/dismiss`;

export const getWebNotificationRoute = (pageNumber: number) =>
    `${getEndpoint(NOTIFICATIONS_MS_NAME)}web_notification/paginated?page=${pageNumber}`;

export const getWebNotificationCountRoute = () => `${getEndpoint(NOTIFICATIONS_MS_NAME)}web_notification/count`;
